<template>
  <b-card class="shadow-sm">
    <b-card-title class="mb-4 pt-6 px-6 d-flex justify-content-between">
      <div>
        <b-icon icon="bar-chart-fill" variant="primary" class="mr-2" />
        <span>Relação Financeira</span>
      </div>

      <!-- Filtro de Período -->
      <FiltroPeriodo
        :value="periodo"
        default-label="Hoje"
        :auto-apply-on-mount="!ignoreInitialApply"
        @apply="onApplyPeriodo"
      />
    </b-card-title>

    <b-card-body>
      <template v-if="loading">
        <div class="col-12">
          <b-skeleton width="100%" height="18px" class="mx-auto mb-3" />
          <b-skeleton width="100%" height="48px" class="mx-auto" />
        </div>
      </template>

      <template v-else>
        <apexchart height="280" :options="chartOptions" :series="chartSeries" />
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "RelacaoFinanceira",
  components: { FiltroPeriodo },

  props: {
    dados: {
      type: Object,
      default: () => ({ data: { series: [], categories: [] } }),
    },

    // Período atual (pode ser null no boot)
    periodo: { type: Object, default: null },

    // Estado de carregamento
    loading: { type: Boolean, default: false },

    // Evita emitir @apply no mount
    ignoreInitialApply: { type: Boolean, default: true },
  },

  computed: {
    categories() {
      return this.dados?.data?.categories ?? [];
    },
    rawSeries() {
      return Array.isArray(this.dados?.data?.series)
        ? this.dados.data.series
        : [];
    },

    chartSeries() {
      // Define tipo e cor por nome da série
      const colorByName = {
        Receitas: "#2ECC71",
        Despesas: "#E74C3C",
        Total: "#3498DB",
      };

      return this.rawSeries.map((s) => {
        const name = s?.name || "";
        const isTotal = name.toLowerCase() === "total";
        return {
          name,
          data: Array.isArray(s?.data) ? s.data : [],
          type: isTotal ? "line" : "bar",
          color: colorByName[name] || (isTotal ? "#3498DB" : undefined),
        };
      });
    },

    chartOptions() {
      return {
        chart: { toolbar: { show: false } },
        xaxis: { categories: this.categories },
        yaxis: {
          labels: {
            formatter: (v) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 0,
              }).format(v || 0),
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            borderRadiusApplication: "end",
            columnWidth: "60%",
          },
        },
        stroke: { curve: "smooth", width: 3 },
        tooltip: {
          y: {
            formatter: (v) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(v || 0),
          },
        },
        legend: { show: true },
      };
    },
  },

  methods: {
    onApplyPeriodo({ inicio, fim }) {
      this.$emit("change-periodo", { inicio, fim });
    },
  },
};
</script>
